import { render, staticRenderFns } from "./FreeRoundSelector.vue?vue&type=template&id=f56ae646&scoped=true&"
import script from "./FreeRoundSelector.vue?vue&type=script&lang=js&"
export * from "./FreeRoundSelector.vue?vue&type=script&lang=js&"
import style0 from "./FreeRoundSelector.vue?vue&type=style&index=0&id=f56ae646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56ae646",
  null
  
)

export default component.exports